import { computed, inject, Injectable, signal } from '@angular/core';
import { ICustomerDetails } from '@dxp/core/models';
import { Observable, tap } from 'rxjs';
import { MediaType } from '@dxp/core/types';
import { EndCustomerApiService } from './end-customer.api.service';

export type ViewType = 'details' | 'directory';

@Injectable({
    providedIn: 'root',
})
export class EndCustomerStateService {
    readonly #endCustomerApiService = inject(EndCustomerApiService);

    readonly #view = signal<ViewType>('details');
    readonly #businessUnit = signal<string | null>(null);
    readonly #conversation = signal<string | undefined>(undefined);
    readonly #mediaType = signal<MediaType | undefined>(undefined);
    readonly #activeEndCustomer = signal<ICustomerDetails | undefined>(
        undefined,
    );
    readonly #selectedEndCustomer = signal<ICustomerDetails | undefined>(
        undefined,
    );

    activeEndCustomer = computed<ICustomerDetails | undefined>(() =>
        this.#activeEndCustomer(),
    );
    selectedEndCustomer = computed<ICustomerDetails | undefined>(() =>
        this.#selectedEndCustomer(),
    );
    view = computed<ViewType>(() => this.#view());
    bussinesUnit = computed<string | null>(() => this.#businessUnit());
    conversation = computed<string | undefined>(() => this.#conversation());
    isActiveCustomerSelected = computed<boolean>(
        () =>
            this.#activeEndCustomer()?.customerId ===
            this.selectedEndCustomer()?.customerId,
    );
    mediaType = computed<MediaType | undefined>(() => this.#mediaType());

    setActiveEndCustomer(customerId: string): Observable<ICustomerDetails> {
        return this.#endCustomerApiService
            .retrieveCustomer(customerId)
            .pipe(tap(customer => this.#activeEndCustomer.set(customer)));
    }

    setSelectedEndCustomer(customer?: ICustomerDetails) {
        this.#selectedEndCustomer.set(customer);
    }

    setView(view: ViewType) {
        this.#view.set(view);
    }

    setBusinessUnit(bussinesUnit: string | null) {
        this.#businessUnit.set(bussinesUnit);
    }

    setConversation(conversationId?: string) {
        this.#conversation.set(conversationId);
    }

    setMediaType(mediaType?: MediaType) {
        this.#mediaType.set(mediaType);
    }
}
